export default __webpack_public_path__ + "static/media/html.a577af37.png";